import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            school: null,
            schools: [], // list of schools user can manage (owner/assistant)
            currentSchoolId: null,
            attendanceTeachers: null,
        }
    },
    mutations,
    actions,
    getters
}